import React from "react";
import {
  TextField,
  Box,
  Grid2
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  hamperTypeOptions,
  hamperCodeOptions,
  hamperColourOptions,
  hamperSizeOptions,
} from "../constants/closetOptions";


export const createEmptyHamperRow = () => ({
  hamperquantity: "",
  hampertype: "",
  hampercode: "",
  hampercolour: "",
  hampersize: "",
});

export default function HamperRowFields({ row, index, onFieldChange, fieldErrors = {} }) {
  const { hamperquantity, hampertype, hampercode, hampercolour, hampersize } = row;

  const codes = hampertype ? hamperCodeOptions[hampertype] || [] : [];
  const colours = hampertype ? hamperColourOptions[hampertype] || [] : [];
  const sizes = hampertype ? hamperSizeOptions[hampertype] || [] : [];

  const hasError = (field) => !!fieldErrors[`${index}-${field}`];

  return (
    <>
      {/* Row 1: Hamper Quantity + Hamper Type */}
      <Grid2 container spacing={2}>
        <Grid2 size={6}>
          <TextField
            fullWidth
            label="Hamper Quantity"
            type="text"
            value={hamperquantity || ""}
            error={hasError("hamperquantity")}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || /^[1-9]\d*$/.test(value)) {
                onFieldChange(index, { hamperquantity: value });
              }
            }}
          />
        </Grid2>
        <Grid2 size={6}>
          <Autocomplete
            options={hamperTypeOptions}
            value={hamperTypeOptions.includes(hampertype) ? hampertype : null}
            onChange={(_, v) =>
              onFieldChange(index, {
                hampertype: v || "",
                hampercode: "",
                hampercolour: "",
                hampersize: "",
              })
            }
            renderInput={(params) => (
              <TextField {...params} label="Hamper Type" error={hasError("hampertype")} />
            )}
          />
        </Grid2>
      </Grid2>

      {/* Row 2: Hamper Code + Hamper Colour */}
      <Grid2 container spacing={2} sx={{ mt: 2 }}>
        <Grid2 size={6}>
          {hampertype && codes.length > 0 ? (
            <Autocomplete
              options={codes}
              value={codes.includes(hampercode) ? hampercode : null}
              onChange={(_, v) => onFieldChange(index, { hampercode: v || "" })}
              renderInput={(params) => (
                <TextField {...params} label="Hamper Code" error={hasError("hampercode")} />
              )}
            />
          ) : (
            <Box />
          )}
        </Grid2>
        <Grid2 size={6}>
          {hampertype && colours.length > 0 ? (
            <Autocomplete
              options={colours}
              value={colours.includes(hampercolour) ? hampercolour : null}
              onChange={(_, v) => onFieldChange(index, { hampercolour: v || "" })}
              renderInput={(params) => (
                <TextField {...params} label="Hamper Colour" error={hasError("hampercolour")} />
              )}
            />
          ) : (
            <Box />
          )}
        </Grid2>
      </Grid2>

      {/* Row 3: Hamper Size */}
      <Grid2 container spacing={2} sx={{ mt: 2 }}>
        <Grid2 size={6}>
          {hampertype && sizes.length > 0 ? (
            <Autocomplete
              options={sizes}
              value={sizes.includes(hampersize) ? hampersize : null}
              onChange={(_, v) => onFieldChange(index, { hampersize: v || "" })}
              renderInput={(params) => (
                <TextField {...params} label="Hamper Size" error={hasError("hampersize")} />
              )}
            />
          ) : (
            <Box />
          )}
        </Grid2>
        <Grid2 size={6} />
      </Grid2>
    </>
  );
}
